import React from "react";
import ReactDOM from "react-dom";
import VodPackageSection from "../components/VodPackageSection";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderVodPackageSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<VodPackageSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering VodPackageSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
